import axios from "axios";
import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getNewsroomCategories = async () => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.NEWSROOM.GET_CATEGORIES);
  return response;
};

// The backend only proxies /categories (see studentEndpoints.js), not
// posts-by-category, so this calls the public apeejay.news WordPress REST
// API directly for the posts within a selected category. It's a public,
// unauthenticated third-party endpoint — deliberately using plain axios
// here, not studentApi, so our own Authorization/organization-id/session-id
// headers are never sent to an external site.
const NEWS_SITE_API_BASE = "https://apeejay.news/wp-json/wp/v2";

export const getNewsroomPosts = async (categoryId, { page = 1, perPage = 10 } = {}) => {
  const response = await axios.get(`${NEWS_SITE_API_BASE}/posts`, {
    params: { categories: categoryId, _embed: true, page, per_page: perPage },
  });
  return response;
};
